import FIELDS from '../PoliceReportFields';
import { isEmpty } from 'utils/TextUtils';

// Mandatory fields (always required)
const mandatoryFieldsRH = [
  FIELDS.NAME_KEY,
  FIELDS.SURNAME_KEY,
  // FIELDS.CONTACTTYPE_KEY,
  // FIELDS.CONTACTVALUE_KEY,
];

function isMandatoryFieldEmptyRH(report, field) {
  return mandatoryFieldsRH.includes(field) && isEmpty(report?.[field]);
}

function getFieldValidationsRH(report, translate) {
  const fieldValidations = {
    [FIELDS.CONTACTVALUE_KEY]: {
      validate: guest => {
        const contactType = guest?.[FIELDS.CONTACTTYPE_KEY] || '';
        const contactValue = guest?.[FIELDS.CONTACTVALUE_KEY] || '';

        if (!contactValue.length) return false;

        if (contactType === 'email') {
          const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
          return contactValue.length <= 60 && emailRegex.test(contactValue);
        } else if (contactType === 'telefono') {
          const phoneNormalized = contactValue.replace(/\s+/g, '');
          const phoneRegex = /^\+?\d{5,20}$/;
          return phoneRegex.test(phoneNormalized);
        }

        // Invalid contact type
        return false;
      },
    },
  };

  if (translate) {
    fieldValidations[FIELDS.CONTACTVALUE_KEY].error = translate('policeReport.error.contactError');
  }

  return fieldValidations;
}

export default { isMandatoryFieldEmptyRH, getFieldValidationsRH };
